import { Environment } from './environment';

export const environmentMX: Environment = {
  referAndWinUrl: 'https://refiereygana.aptuno.mx/',
  segmentAnalyticsApiKey: 'IDmh1ZXoUCHG9e5KRzMfJ2ub5iT3UrFG',
  decimalSeparator: '.',
  groupSeparator: ',',
  thousandSeparator: ',',
  urlLogin: '/ingreso',
  hotjarHJID: 2816406,
  hotjarHJSV: 6,
  sentryDNS: '',
  gcpStorage: {
    baseUrl: 'https://storage.googleapis.com/aptuno-assets-mx',
    cdnBaseUrl: 'https://cdn.aptuno.mx',
  },
  plans: {
    aptunoBrokerage: {
      friendlyName: 'Corretaje Aptuno',
      includes: [
        {
          text: '<strong>Publicación</strong> en Aptuno y en portales aliados',
          icon: 'plus',
        },
        {
          text: '<strong>Búsqueda del inquilino ideal</strong> para tu inmueble en tiempo récord',
          icon: 'plus',
        },
        {
          text: '<strong>Acompañamiento en visitas</strong> con agentes certificados',
          icon: 'plus',
        },
        {
          text: '<strong>Elaboración de contrato digital</strong> 100% seguro y fácil de llenar',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>Primer renta</strong> (incluyendo mantenimiento) al momento de la firma de contrato',
          icon: 'currency',
        },
      ],
    },
    aptunoWarranty: {
      friendlyName: 'Garantía Aptuno',
      includes: [
        {
          text: 'Todo lo que incluye el plan',
          referencePlanText: 'Corretaje Aptuno',
          referencePlanColor: '#F0AE00',
          icon: 'check',
        },
        {
          text: '<strong>Garantía de pago puntual</strong> de renta y mantenimiento hasta 12 meses',
          icon: 'plus',
        },
        {
          text: '<strong>Verificación de perfiles</strong> y estudio de crédito para inquilinos',
          icon: 'plus',
        },
        {
          text: '<strong>Asesoría jurídica</strong> en todo lo relacionado al contrato de arrendamiento',
          icon: 'plus',
        },
        {
          text: '<strong>Póliza jurídica</strong> básica hasta por $50.000 MXN',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>4% del valor de renta mensual + mantenimiento</strong> a partir del segundo mes de contrato',
          icon: 'currency',
        },
      ],
    },
    blueAptuno: {
      friendlyName: 'Aptuno Azul',
      includes: [
        {
          text: 'Todo lo que incluye el plan',
          referencePlanText: 'Garantía Aptuno',
          referencePlanColor: '#D250E6',
          icon: 'check',
        },
        {
          text: '<strong>Gestión de reparaciones</strong> y mantenimiento del inmueble',
          icon: 'plus',
        },
        {
          text: '<strong>Seguro de todo riesgo</strong> en alianza con Zurich',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>8% del valor de renta mensual + mantenimiento</strong> a partir del segundo mes de contrato',
          icon: 'currency',
        },
      ],
    },
    aptunoPlus: {
      friendlyName: 'Aptuno Plus',
      includes: [
        {
          text: 'Todo lo que incluye el plan',
          referencePlanText: 'Aptuno Azul',
          referencePlanColor: '#0055FB',
          icon: 'check',
        },
        {
          text: '<strong>Garantía de pago puntual</strong> de renta y mantenimiento hasta 24 meses',
          icon: 'plus',
        },
        {
          text: '<strong>Póliza jurídica</strong> con exinción de dominio hasta por $50.000 MXN',
          icon: 'plus',
        },
        {
          text: '<strong>Seguro con Zurich</strong> Hogar plus + Cristales +  Terremoto',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>10% del valor de renta mensual + mantenimiento</strong> a partir del segundo mes de contrato',
          icon: 'currency',
        },
      ],
    },
  },
  chatBotAgentId: 'XYZ',
  capturingAgent: {
    bucketUploadDocument: 'capturing-agent-mx',
  },
  gtmId: process.env.GTM_ID || '',
};
